<template>
  <v-card>
    <v-card-text class="d-flex justify-space-between align-center">
      <div class="sensor-img d-flex align-center">
        <v-img :src="sensorAvatar" max-width="150"></v-img>
        <div class="sensor-desc">
          <div
            class="d-flex sensor-mac-address text-h4 font-weight-medium my-1"
          >
            {{ sensor.macAddress }}
          </div>
          <div class="d-flex sensor-name">
            <v-icon class="sensor-icon" small>fa-microchip</v-icon>
            <div>Nom : {{ sensor.nickname }}</div>
          </div>
          <div class="d-flex sensor-place">
            <v-icon class="sensor-icon" small>fa-map-marker-alt</v-icon>
            <div class="text-justify">
              {{ sensor.place == "" ? "-" : sensor.place }}
            </div>
          </div>
        </div>
      </div>
      <div class="sensor-desc-2 d-flex align-center">
        <div>
          <div class="d-flex justify-space-between sensor-created my-2">
            <div class="text-button">Créé</div>
            <div class="text-button">{{ sensor.createdAt | dateFilter }}</div>
          </div>
          <div class="d-flex justify-space-between sensor-connection my-2">
            <div class="mr-16 text-button">Mode</div>
            <div class="text-button d-flex align-center font-weight-bold grey--text">
              <v-img
                :src="sensor.connectionType == 'BLE' ? ble : lora"
                max-width="40"
              ></v-img>
              <div>- {{ sensor.connectionType == "BLE" ? "Bluetooth" : "LoRaWAN" }}</div>
            </div>
          </div>
          <div class="d-flex justify-space-between sensor-provider">
            <div class="text-button">Fournisseur</div>
            <div class="text-button font-weight-bold primaryColor--text">
              <v-img
                v-if="sensor.provider == 'ORANGE'"
                :src="orangeProvider"
                max-width="35"
              >
              </v-img>
              <v-img
                v-else-if="sensor.provider == 'OBJENIOUS'"
                :src="objeniousProvider"
                max-width="70"
              >
              </v-img>
              <v-img v-else :src="clientProvider" max-width="50"></v-img>
            </div>
          </div>
        </div>
        <div class="sensor-qrcode mx-5">
          <VueQrcode :value="`${sensor.macAddress}-${sensor.createdAt}`" :options="{ width: 150 }" />
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import sensorAvatar from "@/assets/icons/sensor.png";
import ble from "@/assets/icons/ble.gif";
import lora from "@/assets/icons/lorawan.gif";
import orangeProvider from "@/assets/icons/orange.png";
import objeniousProvider from "@/assets/icons/objenious.png";
import clientProvider from "@/assets/icons/client.gif";
import dateFilter from "@filters/dateFilter";
import VueQrcode from "@chenfengyuan/vue-qrcode";


export default {
  name: "SensorDescription",
  components: {
    VueQrcode
  },
  props: {
    sensor: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    sensorAvatar,
    ble,
    lora,
    orangeProvider,
    objeniousProvider,
    clientProvider,
  }),
  filters: {
    dateFilter,
  },
};
</script>

<style>
.sensor-icon {
  margin-right: 12px;
  padding: 5px 0;
}
</style>
